export const appActionTypes = {
    CONFIGS_LOADED: 'CONFIGS_LOADED',

    SET_APP_CONFIG: 'SET_APP_CONFIG',
    SET_CLIENT_CONFIG: 'SET_CLIENT_CONFIG',
    SET_LANGUAGE: 'SET_LANGUAGE',

    GO_TO_EXTERNAL_LINK: 'GO_TO_EXTERNAL_LINK',
    GO_TO_AGREEMENT: 'GO_TO_AGREEMENT',

    EXPIRED_SESSION_FOUND: 'EXPIRED_SESSION_FOUND',
};

export const WHITELIST_ROUTES = [
    '/cookie-policy',
    '/cookie-manager',
    '/points-terms-of-use',
    '/about',
];

export const REGION = {
    EU: 'EU',
    JP: 'JP',
    AP: 'AP',
};

export const TEST_CLIENT_ID = {
    AM_UK: 'am_uk_test',
    JPN: 'jpn_test',
    MYR_STD_WEB: 'myr_std_web',
};

export const MYR_STANDALONE_CLIENT_ID = 'myr_std_web';
